/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCompass3Filled: {
  name: 'compass-3-filled';
  data: string;
} = {
  name: 'compass-3-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.76 3.028c-.673.242-11.289 4.416-11.453 4.503a2.065 2.065 0 0 0-.776.776c-.19.362-4.489 11.389-4.516 11.586-.082.596.48 1.166 1.081 1.097.184-.021 11.232-4.328 11.597-4.521.297-.157.619-.479.776-.776.191-.361 4.489-11.387 4.516-11.585.061-.444-.243-.919-.669-1.045-.208-.062-.44-.077-.556-.035M18.203 5.85c-.641 1.661-3.456 8.818-3.477 8.839-.015.016-1.251-1.194-2.745-2.688-1.495-1.495-2.709-2.724-2.699-2.732.014-.011 8.913-3.499 8.947-3.507.005-.001-.007.038-.026.088"/></svg>`
};
